export const ISLOADED = 'ISLOADED';
export const CURSOR = 'CURSOR';
export const TRANSITION = 'TRANSITION';
